import React, { useState, useEffect } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

const EditEmployeeModal = ({ employee, isOpen, onClose, setNotification }) => {
    const [name, setName] = useState('');

    useEffect(() => {
        if (employee) {
            setName(employee.name);
        }
    }, [employee]);

    if (!isOpen) return null;

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const employeeRef = doc(db, "employees", employee.id);
            await updateDoc(employeeRef, { name });
            setNotification({ type: 'success', message: 'Employee updated successfully!' });
            onClose();
        } catch (error) {
            setNotification({ type: 'error', message: 'Failed to update employee.' });
        }
    };
    
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-md">
                <h3 className="text-xl font-bold text-slate-800 mb-4">Edit Employee</h3>
                <form onSubmit={handleUpdate}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-slate-700 mb-1">Full Name</label>
                        <input value={name} onChange={e => setName(e.target.value)} className="w-full p-2 border rounded-md" required />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
                        <input value={employee.email} className="w-full p-2 border rounded-md bg-slate-100" disabled />
                    </div>
                     <div className="flex justify-end gap-3">
                        <button type="button" onClick={onClose} className="bg-slate-200 text-slate-800 font-semibold py-2 px-4 rounded-md hover:bg-slate-300">Cancel</button>
                        <button type="submit" className="bg-indigo-600 text-white font-semibold py-2 px-4 rounded-md hover:bg-indigo-700">Save Changes</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditEmployeeModal;
